import qs from 'qs';

import { Pipeline } from 'src/components/pipelines/models';
import { getStepPageURL } from 'src/components/pipelines/utils/links';

import {
  RepositoryDynamicPipelinesParams,
  WorkspaceDynamicPipelinesParams,
} from './models/DynamicPipelines';
import { WorkspaceThirdPartySecretsParams } from './models/SecretProvider';
import { formatUuid } from './utils';
import envBaseUrl from './utils/env-base-url';

export const getKnownHostsUrl = (
  repoPath: string,
  page?: string | number,
  pagelen?: string | number,
  uuid?: string
): string => {
  const query = qs.stringify({
    page,
    pagelen,
  });
  return `${repoPath}/pipelines_config/ssh/known_hosts${
    uuid ? `/${uuid}` : '/'
  }${query ? `?${query}` : ''}`;
};

export function getArtifactsPageURL(
  repoPath: string,
  pipelineUuid: string,
  stepUuid: string,
  runUuid?: string
): string {
  return `${getStepPageURL(
    { uuid: pipelineUuid },
    stepUuid,
    repoPath,
    runUuid
  )}/artifacts`;
}

export function getMetricsPageURL(
  repoPath: string,
  pipelineUuid: string,
  stepUuid: string,
  runUuid?: string
): string {
  return `${getStepPageURL(
    { uuid: pipelineUuid },
    stepUuid,
    repoPath,
    runUuid
  )}/metrics`;
}

export function getServicePageURL(
  repoPath: string,
  pipelineUuid: string,
  stepUuid: string,
  serviceUuid?: string,
  runUuid?: string
): string {
  return `${getStepPageURL(
    { uuid: pipelineUuid },
    stepUuid,
    repoPath,
    runUuid
  )}${serviceUuid ? `/services/${formatUuid(serviceUuid)}` : ''}`;
}

export function getTestReportPageURL(
  repoPath: string,
  pipeline: Pipeline | { uuid: string; buildNumber?: number },
  stepUuid: string,
  runUuid?: string
): string {
  return `${getStepPageURL(pipeline, stepUuid, repoPath, runUuid)}/test-report`;
}

export function getDeploymentsSettingsPageURL(repoPath: string) {
  return `/${repoPath}/admin/pipelines/deployment-settings`;
}

export function getPipelinesSettingsPageURL(repoPath: string) {
  return `/${repoPath}/admin/pipelines/settings`;
}

export function getAdminPlansPageUrl(workspace: string) {
  return `/${workspace}/workspace/settings/plans-and-billing`;
}

export function getWorkspaceVariablesPageUrl(workspace: string) {
  return `/${workspace}/workspace/settings/pipelines/account-variables`;
}

export function getWorkspaceRunnersPageUrl(workspace: string) {
  return `/${workspace}/workspace/settings/pipelines/account-runners`;
}

export function getWorkspaceDynamicPipelinesPageUrl(workspace: string) {
  return `/${workspace}/workspace/settings/pipelines/dynamic-pipelines`;
}

export const getWorkspaceDynamicPipelinesProvidersUrl = (
  params: WorkspaceDynamicPipelinesParams
) => {
  return `${envBaseUrl('/!api/internal')}/workspaces/${
    params.workspaceSlug
  }/pipelines-config/dynamic-pipelines-provider`;
};

export const getRepositoryDynamicPipelinesProvidersUrl = (
  params: RepositoryDynamicPipelinesParams
) => {
  const { repositoryOwner, repositorySlug } = params;
  return `${envBaseUrl(
    '/!api/internal'
  )}/repositories/${repositoryOwner}/${repositorySlug}/pipelines-config/dynamic-pipelines-provider`;
};

export const getThirdPartySecretsProviderUrl = (
  params: WorkspaceThirdPartySecretsParams
) => {
  return `${envBaseUrl('/!api/internal')}/workspaces/${
    params.workspaceSlug
  }/pipelines-config/third-party-secrets-provider`;
};
